import { useEffect, useState } from "react";

import { Box, Card, Grow, Skeleton, Stack, Typography } from "@mui/material";

import { LOGO_WHITE } from "Configs/core";

import { useAppSelector } from "Hooks/useRedux";

import { getLocationData } from "Helper/map";

interface IData {
  district: string;
  address: string;
}

export default function LocationData() {
  const { visible } = useAppSelector((state) => state.locationData);
  const { mouse } = useAppSelector((state) => state.map);

  const [data, setData] = useState<IData>();

  useEffect(() => {
    if (visible && mouse)
      getLocationData({ lat: mouse?.lat, lng: mouse?.lng }).then((res) => {
        const { province, district, formattedAddress } = res;
        setData({
          district: `${province} ${district ? `- ${district}` : ""}`,
          address: formattedAddress,
        });
      });
  }, [mouse]);

  return (
    <Grow in={visible}>
      <Card sx={{ width: "400px" }} className="fa-number">
        <Stack direction="row" alignItems="center">
          <Box sx={{ minWidth: "56px", height: "56px", bgcolor: "secondary.main", display: "grid", placeItems: "center" }}>
            <img src={LOGO_WHITE} alt="logo" />
          </Box>

          <Stack sx={{ px: 1, width: "calc(100% - 56px)" }}>
            {data ? (
              <>
                <Typography noWrap sx={{ fontWeight: "600", fontSize: "14px" }}>
                  {data?.district}
                </Typography>
                <Typography noWrap sx={{ fontSize: "14px" }}>
                  {data?.address}
                </Typography>
              </>
            ) : (
              <>
                <Skeleton width="50%" />
                <Skeleton width="100%" />
              </>
            )}
          </Stack>
        </Stack>
      </Card>
    </Grow>
  );
}
